import AddinCommand from '../store/schema/AddinCommand';
import getExtensibilityState from '../store/getExtensibilityState';
import { action } from 'satcheljs/lib/legacy';
import { ObservableMap } from 'mobx';
import ExtensionEventResult from '../store/schema/ExtensionEventResult';
import { setPendingUILess } from '../store/pendingUILess';

export default action('setUilessAddinCommand')(function setUilessAddinCommand(
    controlId: string,
    addinCommand: AddinCommand,
    hostItemIndex: string
): Promise<ExtensionEventResult> {
    const pendingUILess = setPendingUILess(controlId);

    const runningUILessAddinCommands = getExtensibilityState().runningUILessAddinCommands;
    if (!runningUILessAddinCommands.has(hostItemIndex)) {
        runningUILessAddinCommands.set(hostItemIndex, new ObservableMap<string, AddinCommand>());
    }
    runningUILessAddinCommands.get(hostItemIndex).set(controlId, addinCommand);

    return pendingUILess;
});
